export enum PARTNER_STATUS {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export enum PARTNER_ACTION {
  EDIT = 'edit',
  DELETE = 'delete',
}

export enum PARTNER_ERROR_CODE {
  SLUG_ALREADY_IN_USE = 'PARTNER_SLUG_ALREADY_IN_USE',
  HAS_ORGANIZATIONS = 'PARTNER_HAS_ORGANIZATIONS',
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
}

export interface Partner {
  id: string;
  slug: string;
  display_name: string;
  tenant_id: string;
  tenant_slug: string;
  logo?: string;
  status: PARTNER_STATUS;
  created_at: string;
  updated_at: string;
}

/** Also creates the partner's first admin, who signs in with `email` and `password`. */
export interface PartnerCreateRequest {
  slug: string;
  display_name: string;
  email: string;
  password: string;
  logo?: string;
}

/** Fields left out stay unchanged; `logo: null` removes the logo. */
export interface PartnerPatchRequest {
  display_name?: string;
  logo?: string | null;
  status?: PARTNER_STATUS;
}
